export var Action;
(function (Action) {
    Action["VideoStart"] = "video:start";
    Action["VideoEnd"] = "video:end";
})(Action || (Action = {}));
